// libraries
import React from 'react'
import clsx from 'clsx'

// prop types
export interface SectionDividerProps {
    marginTop?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    marginBottom?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    className?: string
}

export default function SectionDivider({
    marginTop,
    marginBottom,
    className
}: SectionDividerProps) {
    return (
        <div className={clsx(
            'section-divider',
            className,

            // margins
            marginTop === 'smaller' && 'margin--top-smaller',
            marginTop === 'small' && 'margin--top-small',
            marginTop === 'medium' && 'margin--top-medium',
            marginTop === 'big' && 'margin--top-big',
            marginTop === 'none' && 'margin--top-none',
            marginBottom === 'smaller' && 'margin--bottom-smaller',
            marginBottom === 'small' && 'margin--bottom-small',
            marginBottom === 'medium' && 'margin--bottom-medium',
            marginBottom === 'big' && 'margin--bottom-big',
            marginBottom === 'none' && 'margin--bottom-none'
        )}>
            <div className='container'>
                <hr />
            </div>
        </div>
    )
}